module.exports = __webpack_public_path__ + "static/media/collegebranchLoginpage.7d88e754.png";